import React from 'react';
import {
  Box,
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Stack,
  Tooltip,
  Button,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import DownloadIcon from '@mui/icons-material/Download';

const FiltrosBar = ({
  searchTerm,
  setSearchTerm,
  filtroMontoMin,
  setFiltroMontoMin,
  filtroMontoMax,
  setFiltroMontoMax,
  limpiarFiltros,
  handleExportCSV,
  totalResultados,
  totalFiltrados,
  loading,
}) => {
  return (
    <Box sx={{ mb: 1, p: 1, bgcolor: '#f8f9fa', borderRadius: 1 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={4}>
          <TextField
            size="small"
            fullWidth
            placeholder="Buscar por referencia, cliente o pedido..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTerm('')}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={6} md={2}>
          <TextField
            size="small"
            fullWidth
            type="number"
            label="Monto mínimo"
            value={filtroMontoMin}
            onChange={(e) => setFiltroMontoMin(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
          />
        </Grid>

        <Grid item xs={6} md={2}>
          <TextField
            size="small"
            fullWidth
            type="number"
            label="Monto máximo"
            value={filtroMontoMax}
            onChange={(e) => setFiltroMontoMax(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Stack direction="row" spacing={1}>
            <Tooltip title="Limpiar filtros">
              <Button
                variant="outlined"
                size="small"
                onClick={limpiarFiltros}
                startIcon={<ClearIcon />}
                fullWidth
              >
                Limpiar
              </Button>
            </Tooltip>
            <Tooltip title="Exportar a CSV">
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={handleExportCSV}
                startIcon={<DownloadIcon />}
                fullWidth
                disabled={totalResultados === 0 || loading}
              >
                Exportar
              </Button>
            </Tooltip>
          </Stack>
        </Grid>
      </Grid>

    </Box>
  );
};

export default FiltrosBar;